import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, ViewChildren, HostListener } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountsService } from 'src/app/core/services/accounts.service';
import { MenuService } from 'src/app/core/services/menu.service';
import { CompanySwitcherService } from '@mitel/cloudlink-console-components';
import { of } from 'rxjs';

@Component({
  selector: 'app-company-name-dropdown',
  templateUrl: './company-name-dropdown.component.html',
  styleUrls: ['./company-name-dropdown.component.scss']
})
export class CompanyNameDropdownComponent implements OnInit {
  @ViewChild('ignoreButton', { read: ElementRef, static: true }) ignoreButton: ElementRef;
  @ViewChildren('listItem', { read: ElementRef }) listItems: ElementRef [];
  @Output() ignoreClick: EventEmitter<any> = new EventEmitter();
  @Output() inputChange: EventEmitter<any> = new EventEmitter();
  @Output() outsideClick: EventEmitter<any> = new EventEmitter();
  @Input() filterName: string;
  accounts = [];
  isOpen = false;
  
  constructor(
    private elRef: ElementRef,
    private accountsService: AccountsService,
    private menuService: MenuService,
    private companySwitcherService: CompanySwitcherService) { }

  ngOnInit() {}

  goToEditAccount(chosenAccount) {
    let account = this.accounts.find((acc) => acc.accountId === chosenAccount.accountId);
		this.menuService.initialRoute = ['accounts', account.accountId];
		this.menuService.isSwitcherProcessingRequired = true;
		this.companySwitcherService.setCurrentAccount(account);
  }

  @HostListener('document:click', ['$event'])
  mouseDownOutside(event) {
    if (!this.elRef.nativeElement.contains(event.target) && this.isOpen) {
      this.isOpen = false;
      this.outsideClick.emit(true);
    } else {
      this.isOpen = true;
    }
  }

  ignoreDuplicates() {
    this.ignoreClick.emit('ignoreClick');
  }

  showDuplicates() {
    if(this.filterName != undefined) {
      const formattedName = this.filterName.trim().toLowerCase();
    
      if (formattedName !== '') {
        setTimeout(() => { this.ignoreButton.nativeElement.focus() });
        // filters out the deactivated accounts
        this.accounts = this.accountsService.accounts.filter(account => 
          account.name.toLocaleLowerCase().indexOf(formattedName) !== -1 &&
          account.active
        );
      }  
    }
  }

  onAccountKeyDown(event, chosenAccount) {
    if (event.key === "Enter") {
      this.goToEditAccount(chosenAccount);
    }
  }
}
